import { useMutation } from '@tanstack/react-query';

import { uploadDocumentsInAssu } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useUploadDocumentsAssu() {
  return useMutation({
    mutationFn: ({
      crmPartyId,
      documents,
    }: {
      crmPartyId: string;
      documents: Array<{
        filename: string;
        link: string;
      }>;
    }) =>
      uploadDocumentsInAssu(
        {
          params: {
            path: { assu_id: crmPartyId },
            query: {},
          },
          body: {
            documents,
          },
        },
        wgApi,
      ),
  });
}
